// extracted by mini-css-extract-plugin
export default {"SiteDetails":"SiteDetails_SiteDetails__CVehH","header":"SiteDetails_header__zb45p","MigrationFlexBox":"SiteDetails_MigrationFlexBox__XkZRG"};